/* eslint-disable max-len */
export const WARRANTY_FAQ_DATA = [
  {
    open: false,
    question: 'What is NOT covered on the Free Warranty Policy?',
    answer: `<div class="accordion__content rte" id="CollapsibleAccordion-16595364608fed54ff-0-template--14592088375370__1659536461384114fd" role="region" aria-labelledby="Summary-16595364608fed54ff-0-template--14592088375370__1659536461384114fd">
                    <p>- Any damage or malfunction arising out of or directly caused by liquid ingress</p><p>- Gradual wear and tear and cosmetic damages that do not affect the device functionality</p><p>- Any damages arising out of negligence or intentional malpractice</p><p>- Any loss/deletion/corruption of any data stored on the device</p>
                    
                  </div>`,
    questionAr: 'ما الذي لا تغطيه سياسة الضمان المجاني؟',
    answerAr: `
   
                    <p>أي ضرر أو عطل ناجم عن دخول السائل في الجهاز</p><p>الأضرار الشكلية التي لا تؤثر على وظائف الجهاز</p><p>أي أضرار ناتجة عن الإهمال أو سوء التصرف المتعمد</p><p>أي فقدان / حذف / تلف لأي بيانات مخزنة على الجهاز</p>
                    
                  `,
  },
  {
    open: false,
    question: 'How does it work?',
    answer: `
                    <p>- Any damage or malfunction arising out of or directly caused by liquid ingress</p><p>- Gradual wear and tear and cosmetic damages that do not affect the device functionality</p><p>- Any damages arising out of negligence or intentional malpractice</p><p>- Any loss/deletion/corruption of any data stored on the device</p>
                    
             `,
    questionAr: 'كيف تعمل؟',
    answerAr: `
                    <p>ستحتاج إلى تقديم طلب ضمان إلى فريق خدمة العملاء لدينا ، والذي سيتواصل معك ويقدم لك بطاقة إرجاع مجانية في أقرب وقت ممكن. سيُطلب منك تقديم تفاصيل عن الشراء والعطل. بمجرد استلامنا للمنتج المرتجع ، سيتم فحصه وإصلاحه / استبداله. في حالة عدم إمكانية الإصلاح أو الاستبدال ، سنقوم بترتيب استرداد جزئي أو كامل للمنتج نقدًا أو عبر رصيد المتجر. نهدف إلى تسوية جميع مطالباتنا في غضون 10 أيام عمل.</p><p>يرجى ملاحظة أنك أنت المسؤول عن تعبئة الجهاز بشكل آمن للشحن. يتحمل المرسل مسؤولية أي ضرر أو خسارة أثناء النقل.</p><p></p>
                    
                `,
  },
];
